import axios from "../../../../axios";
import Cookies from "js-cookie";

export const VerifyCandidate = async (payload) => {
  return axios.post("/api/Consultant/VerifyCandidate", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// Send Candidate API
export const SendCandidate = async (payload) => {
  const formData = new FormData();

  formData.append("Token", payload.Token);
  formData.append("RequestID", payload.RequestID);
  formData.append("CurrentCTC", payload.CurrentCTC || "");
  formData.append("ExpectedCTC", payload.ExpectedCTC || "");
  formData.append("TotalExperience", payload.TotalExperience || "");
  formData.append("CurrentLocation", payload.CurrentLocation || "");
  formData.append("NoticePeriod", payload.NoticePeriod || "");
  formData.append("ReadytoRelocate", String(payload.ReadytoRelocate));
  formData.append("ReasonofLeaving", payload.ReasonofLeaving || "");
  formData.append("Remarks", payload.Remarks || "");
  formData.append("Gender", payload.Gender || "");
  formData.append("PreferredLocation", payload.PreferredLocation || "");
  formData.append("CurrentCompany", payload.CurrentCompany || "");
  formData.append("Qualification", payload.Qualification || "");
  formData.append("DomainExperience", payload.DomainExperience || "");

  if (payload.ResumeFile) {
    formData.append("ResumeFile", payload.ResumeFile);
  }

  return axios.post("/api/Consultant/SendCandidate", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
